var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
var is_node = !!(typeof module == 'object' && module.exports);
define(['/svc/billing/pub/payutils.js', '/svc/billing/pub/providers.js', '/util/etask.js', '/util/zerr.js', 'hola_pub_util', 'lodash'], function (payutils, providers, etask, zerr, hola_pub_util, _) {
  var assign = Object.assign;
  var perr = hola_pub_util.perr;
  var E = {
    t: 'ccardbs',
    dname: 'Credit Card',
    pub_provider: 'bank',
    provider: providers.bluesnap
  };
  E._env = {};
  E._encrypt_ccard_form_data = function (frm) {
    var number = frm.ccard_number,
      cvv = frm.ccard_cvv;
    var encrypted = bs_encrypt({
      number: number,
      cvv: cvv
    });
    var res = assign({}, frm);
    res.ccard_number = encrypted.number;
    res.last_digits = number.slice(-4);
    res.ccard_cvv = encrypted.cvv;
    return res;
  };

  // we use two accounts for bluesnap payments:
  // - regular account (std/ext api), also used as a fallback
  // - reseller account (includes vat for some countries, ext api only)
  E._init_bluesnap = payutils.cached_etask_fn(function (opt, on_err) {
    opt = opt || {};
    var hola_qs = {
      sbx: opt.sbx && 1 || undefined,
      vat: opt.vat && 1 || undefined
    };
    var hola_qs_fallback = opt.vat && _.omit(hola_qs, 'vat');
    return etask([function () {
      this.on('uncaught', function (e) {
        perr({
          id: 'www_bluesnap_init_uncaught_err',
          info: {
            err: zerr.e2s(e)
          }
        });
        zerr('uncaught _init_bluesnap %o', e);
      });
      return etask.all({
        bluesnap_sdk: load_bs('/web-sdk/5/bluesnap.js', 'bluesnap', on_err),
        pf_token: opt.init_hpf && load_token(hola_qs),
        pf_token_fallback: opt.init_hpf && hola_qs_fallback && load_token(hola_qs_fallback)
      });
    }, function (loaded) {
      E._env = {
        opt: opt,
        loaded: loaded
      };
    }]);
  });
  assign(E, {
    autorech: 1,
    auth_evt: 'auth_ccbs',
    crg_evt: 'crg_ccbs',
    ref_evt: 'ref_ccbs'
  });

  // -- utils --

  var bs_encrypt = function bs_encrypt(values) {
    if (!E._env.cse_client) throw new Error('bluesnap was not initialized');
    var single = false;
    if (typeof values != 'object') {
      values = {
        cvv: values
      };
      single = true;
    }
    // generate dummy form: bluesnap only supports encrypting <form> elements
    var form = document.createElement('form');
    form.id = 'bluesnap' + Date.now();
    form.setAttribute('style', 'display:none');
    document.body.appendChild(form);
    var k2bs = {
      number: 'encryptedCreditCard',
      cvv: 'encryptedCvv'
    };
    for (var k in values) {
      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute('data-bluesnap', k2bs[k]);
      input.value = values[k];
      input.name = k;
      form.appendChild(input);
    }
    // encrypt using dummy form
    E._env.cse_client.encrypt(form.id);
    var encrypted = {};
    for (var k2 in values) encrypted[k2] = form.elements[k2bs[k2]].value;
    // finalize
    document.body.removeChild(form);
    return single ? encrypted.cvv : encrypted;
  };
  var load_bs = function load_bs(path, id, on_err) {
    return payutils.load_script('https://gateway.bluesnap.com' + path, id, on_err);
  };
  var load_pk = function load_pk(qs) {
    return payutils.ajax('GET', '/bluesnap_public_key', {
      qs: qs,
      json: 0
    });
  };
  var load_token = function load_token(qs) {
    return payutils.ajax('POST', '/bluesnap_payment_fields_tokens', {
      qs: qs,
      json: 0
    });
  };
  return E;
});